module.exports = __webpack_public_path__ + "img/logo_outline.6466914f.png";